import { combineReducers } from "redux";

import authReducer from "./auth-reducer";
import userReducer from "./user-reducer";

import taskManagementReducers from "./taskManagement";
import procurementsReducers from "./procurements";
import inventoryReducers from "./inventory";
import HRMReducers from "./HRM";

const rootReducer = combineReducers({
  taskManagement: combineReducers({ ...taskManagementReducers }),
  procurements: combineReducers({ ...procurementsReducers }),
  inventory: combineReducers({ ...inventoryReducers }),
  hrm: combineReducers({ ...HRMReducers }),
  auth: authReducer,
  user: userReducer,
});

export default rootReducer;
